import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface mySettingState {
  loading: boolean;
  mySettingUsers: any
  successs: boolean;
  submitSuccess: boolean;
}

const initialState: mySettingState = {
  loading: false,
  mySettingUsers: [],
  successs: false,
  submitSuccess: false,
};

const mySettingSlice = createSlice({
  name: 'mySetting',
  initialState,
  reducers: {
    getUserProfileStart(state) {
      state.loading = true;
    },
    getUserProfileSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      const response = action.payload;
      const finalData = response[0] ? response[0] : response;

      const updatedFormattedData = { ...finalData };
      updatedFormattedData["notifications"] =
        finalData?.notification_type_id?.split(",") || [];

      updatedFormattedData["preferences"] =
        updatedFormattedData?.preferences_type_id?.split(",") || [];
      state.mySettingUsers = updatedFormattedData;

    },
    getUserProfileFailure(state, action) {
      state.loading = false;
    },
    requestAccessStart(state, action: PayloadAction<any>) {
      state.successs = false;
      state.loading = true;
    },
    requestAccessSuccess(state, action: PayloadAction<any>) {
      state.successs = true;
      state.loading = false;
    },
    requestAccessFailure(state) {
      state.successs = false;
      state.loading = false;
    },
    requestSuccess(state, action) {
      state.successs = action.payload
    },
    UpdateUserProfileStart(state, action: PayloadAction<any>) {
      state.submitSuccess = false;
      state.loading = true;
    },
    UpdateUserProfileSuccess(state) {
      state.submitSuccess = true;
      state.loading = false;
    },
    UpdateUserProfileFailure(state) {
      state.submitSuccess = false;
      state.loading = false;
    },
    resetSubmitSuccess(state, action) {
      state.submitSuccess = action.payload;
    }

  }

});

export const {
  getUserProfileFailure,
  getUserProfileStart,
  getUserProfileSuccess,
  requestAccessFailure,
  requestAccessStart,
  requestAccessSuccess,
  requestSuccess,
  UpdateUserProfileFailure,
  UpdateUserProfileStart,
  UpdateUserProfileSuccess,
  resetSubmitSuccess
} = mySettingSlice.actions;

export default mySettingSlice.reducer;